import {
  configApiRef,
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';
import difference from 'lodash/difference';
import { rootRouteRef } from './routes';
import { LaunchDarklyApiRef, LaunchDarklyClient } from './apis';
import { LAUNCHDARKLY_CONTEXT_PROPERTIES_ANNOTATION, LAUNCHDARKLY_ENVIRONMENT_KEY_ANNOTATION, LAUNCHDARKLY_PROJECT_KEY_ANNOTATION } from './constants';

export const launchDarklyPlugin = createPlugin({
  id: 'launch-darkly',
  apis: [
    createApiFactory({
      api: LaunchDarklyApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({discoveryApi, fetchApi }) {
        return  new LaunchDarklyClient(
          {
            discoveryApi,
            fetchApi
          }
        )
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const LaunchDarklyPage = launchDarklyPlugin.provide(
  createRoutableExtension({
    name: 'LaunchDarklyPage',
    component: () =>
      import('./components/EntityLaunchdarklyContent').then(m => m.LaunchdarklyContentComponent),
    mountPoint: rootRouteRef,
  }),
);

export const EntityLaunchdarklyOverviewCard = launchDarklyPlugin.provide(
  createComponentExtension({
    name: 'EntityLaunchdarklyOverviewCard',
    component: {
      lazy: () =>
        import('./components/EntityLaunchdarklyOverviewCard').then(
          m => m.EntityLaunchdarklyOverviewCard,
        ),
    },
  }),
);

export const isLaunchdarklyAvailable = (entity: Entity) => {
  const diff = difference(
    [
      LAUNCHDARKLY_PROJECT_KEY_ANNOTATION,
      LAUNCHDARKLY_CONTEXT_PROPERTIES_ANNOTATION,
      LAUNCHDARKLY_ENVIRONMENT_KEY_ANNOTATION,
    ],
    Object.keys(entity.metadata?.annotations || {}),
  );
  return diff.length === 0;
};
